import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { printCtaCss } from "@/view/FormativeGraphicOrganizerButton/FormativeGraphicOrganizerButton.style";

const { colors } = constants;
const blue = colors.ui.core[700];

export const wrapper: CSSObject = {
  ...printCtaCss,
  marginTop: "1rem",
};

export const externalLinkSvgCss: CSSObject = {
  width: "18px",
  height: "18px",
  verticalAlign: "sub",
  marginLeft: "0.25rem",
};

export const linkCss: CSSObject = {
  color: blue,
  textDecoration: "none",
};
